import React from "react"
import LoadingBlock from "../../components/loader/LoadingBlock";
import ErrorBadGateway from "../../components/error/ErrorBadGateway";
import {useGetPermissionsQuery} from "../../store/api/configurationApi";

interface PermissionProviderProps {
    children?: React.ReactNode
}

const PermissionProvider: React.FC<PermissionProviderProps> = ({children}) => {
    const {isLoading, isError} = useGetPermissionsQuery()
    if (isLoading) return <LoadingBlock/>
    if (isError) return <ErrorBadGateway/>

    return (
        <>
            {children}
        </>
    )
}

export default PermissionProvider
